import React, { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "@emotion/styled";
import { faMagnifyingGlass, faChevronRight, faChevronDown, faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useDetectOutsideClick from "../../../hooks/useDetectOutsideClick";

import Container from "../../Shared/Container";
import Dropdown from "../../Shared/Dropdown";
import ListOfGovs from "./ListOfGovs";

import { COLORS_BASE, STYLES } from "../../../utils/consts";
import { TEXT_DROPDOWN } from "../../../utils/text";
import { searchParamsObj, toSlug } from "../../../utils/dataHandler";
import { GovType, MapType } from "../../../types/dataTypes";
import SubHeader from "../../Shared/SubHeader";
import { SubContainerStyle } from "../../../styles/styles";

type GovDropdownProps = {
  map: MapType;
  gov_adm1: GovType;
};

function GovDropdown({map, gov_adm1} : GovDropdownProps) {
  const [selectedGov, setSelectedGov] = useState<string>("Select a District");
  const containerRef = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const paramsObj = searchParamsObj(searchParams);
  const [viewDropdown, setViewDropdown] = useDetectOutsideClick(
    containerRef,
    false
  );

  return (
    <>
      <SubHeader text={'Zoom to Location'} icon={faMagnifyingGlassPlus} />
      <DropdownButtonStyle
        type="button"
        name="Open options"
        onClick={() => setViewDropdown(!viewDropdown)}
      >
        <Container transition={false} width='100%' margin='0' flex justifyContent="space-between" >
          <div>
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              color={COLORS_BASE.SECONDARY.MAIN}
            />
              &nbsp; {selectedGov}
          </div>
          <FontAwesomeIcon
            icon={viewDropdown == true ? faChevronDown : faChevronRight}
            color={COLORS_BASE.SECONDARY.MAIN}
          />
        </Container>
      </DropdownButtonStyle>
      <Dropdown
        containerRef={containerRef}
        viewcontainerRef={viewDropdown}
        top="0"
        left="0"
        padding="0px"
        margin="10px 0"
      >
        {viewDropdown && <ListOfGovs map={map} setViewDropdown={setViewDropdown} 
        selectedGov={selectedGov} setSelectedGov={setSelectedGov} gov_adm1={gov_adm1} />}
      </Dropdown>
    </>
  );
}

export default GovDropdown;

const DropdownButtonStyle = styled.button<{}>(
  () => `
    background: none;
      color: inherit;
      border: none;
      padding: 0;
      font: inherit;
      cursor: pointer;
      outline: inherit;
      display: flex;
      width: 350px;
      border-radius: 5px;
      border: 2px solid ${COLORS_BASE.GREYS.MAIN};
  `
);
